import React, { useEffect, useState } from "react";
import Filter from "./Filter";
import Table from "./Table";
import "./Roles.css";
import Add_Role from "./Add_Role";
import Edit_Role from "./Edit_Role";
import Success_Toster from "../../../../../common/common_modal/success_toster/Success_Toster";
import { FixIDS } from "../../../../../utils/fixIDS";
import { useSelector } from "react-redux";

const Roles = () => {
  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [searchName, setSearchName] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const permissions = useSelector((state) => state.auth.permissions);
  const havePermission = permissions?.includes(FixIDS.Roles.List);

  return (
    <section className="Roles">
      <div className="filter_div">
        <Filter setSearchName={setSearchName} setAdd={setAdd} />
      </div>

      <div className="sample_table_div">
        {havePermission && (
          <Table
            setEdit={setEdit}
            setEditId={setEditId}
            searchName={searchName}
          />
        )}
      </div>

      <Add_Role
        setSuccess={setSuccess}
        show={add}
        setShow={setAdd}
        handleClose={() => {
          setAdd(false);
        }}
      />
      <Edit_Role
        setSuccess={setSuccess}
        show={edit}
        editId={editId}
        setShow={setEdit}
        handleClose={() => setEdit(false)}
      />
      {success && <Success_Toster successText="Data Save successfully!" />}
    </section>
  );
};

export default Roles;
